import { combineReducers } from "redux";

import AuthReducer from "./authReducer";
import DashboardReducer from "./dashboardReducer";
import FeedbackReducer from "./feedbackReducer";
import MediaReducer from "./mediaReducer";
import PromoCodeReducer from "./promoCodeReducer";
import UserReducer from "./userReducer";
import AdsReducer from "./adsReducer";
import ArtistReducer from "./artistReducer";
import InterviewsReducer from "./interviewsReducer";
import LiveReducer from "./liveReducer";

const RootReducer = combineReducers({
  auth: AuthReducer,
  media: MediaReducer,
  user: UserReducer,
  dashboard: DashboardReducer,
  feedback: FeedbackReducer,
  promoCode: PromoCodeReducer,
  ads: AdsReducer,
  artist: ArtistReducer,
  interviews: InterviewsReducer,
  live: LiveReducer,
});

export default RootReducer;
